import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AiUsageCard = () => {
  const { user } = useAuth();
  const [u, setU] = useState(null);
  const [lim, setLim] = useState("");
  const load = () => api.get("/ai/usage").then((r) => { setU(r.data); setLim((l) => l || String(r.data.limit)); }).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  if (!u) return null;
  const pct = Math.min(100, Math.round((100 * u.used) / Math.max(1, u.limit)));
  const color = pct >= 100 ? "#FF3B30" : pct >= 80 ? "#FF9F0A" : "#32D74B";
  const save = async () => {
    try { const r = await api.put("/ai/usage", { daily: Number(lim) }); setU(r.data); toast.success("Daily AI limit saved"); }
    catch { toast.error("Could not save limit"); }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-[#111] p-4" data-testid="ai-usage-card">
      <div className="flex items-center justify-between text-xs uppercase tracking-wider text-white/50">
        <span>AI checks today</span>
        {u.blocked > 0 && <span className="text-[#FF3B30]" data-testid="ai-usage-blocked">limit hit · {u.blocked} skipped</span>}
      </div>
      <div className="mt-1 text-2xl font-semibold" data-testid="ai-usage-count">
        {u.used.toLocaleString()} <span className="text-sm text-white/40">/ {u.limit.toLocaleString()}</span>
      </div>
      <div className="mt-2 h-1.5 rounded bg-white/10 overflow-hidden">
        <div className="h-full transition-[width] duration-500" style={{ width: `${pct}%`, background: color }} />
      </div>
      {user?.role === "master" && !user?.lock_store && (
        <div className="mt-3 flex items-center gap-2">
          <input type="number" min={0} value={lim} onChange={(e) => setLim(e.target.value)}
            className="w-24 rounded bg-black/40 border border-white/10 px-2 py-1 text-sm" data-testid="ai-usage-limit-input" />
          <button onClick={save} className="rounded bg-white/10 hover:bg-white/20 px-3 py-1 text-xs transition-colors" data-testid="ai-usage-limit-save">Set daily limit</button>
        </div>
      )}
    </div>
  );
};
